<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App',
  created() {
    if (window.safari) { // disable safari back-button on scroll
      history.pushState(null, null, location.href);
      window.addEventListener("popstate",this.handlePopState)
    }
  },
  unmounted() {
    if (window.safari) { // disable safari back-button on scroll
      history.pushState(null, null, location.href);
      window.removeEventListener("popstate",this.handlePopState)
    }
  },
  methods: {
    handlePopState(event) { // disable safari back-button on scroll
      history.go(1);
    }
  },
};
</script>

<style lang="scss">

/* ALERT sass seems to not be compiling parentheses for nested calcs/variables. This may be due to my outdated sass version, or something else... I have worked around it so far, but nested subtractions can easily become a problem*/

$font-size: 16px;
$line-height: 1.25rem;
$page-margin-x: 2rem;
$vertical-spacing: 2rem;

$chat-label-height:calc(1.25rem*3);

$header-padding-top: $vertical-spacing;
$header-padding-bottom: $vertical-spacing/2;
$ref-header-height: $header-padding-top + $header-padding-bottom + $line-height;

$scroller-main-height: 50vh;
$scroller-nav-margin-top: $vertical-spacing/2;
$ref-scroller-height: calc( $scroller-main-height + $scroller-nav-margin-top + $line-height);

$streaminfo-padding-top: $vertical-spacing;
$streaminfo-main-height: calc(100vh - $ref-header-height - $ref-scroller-height - $chat-label-height );
$streaminfo-margin-x: 6rem;
$streaminfo-gap: 4rem;
$ref-streaminfo-height: $streaminfo-main-height; //$streaminfo-padding-top excluded due to box-sizing

$irc-top: calc( ($ref-header-height) + ($ref-streaminfo-height) + (1.5*$vertical-spacing) );
$irc-height: calc(100vh - ($irc-top) - ($line-height*3) );

$page-height: calc(200vh - $scroller-main-height - $scroller-nav-margin-top - $line-height);

$mobile-font-size: 16px;
$mobile-line-height: 1.25rem;
$mobile-vertical-spacing: 2rem;
$mobile-page-margin-x: 1rem;
$mobile-head-height: $mobile-line-height*4;


html {
  font-family: 'UniversLTPro';
  font-size: $font-size;
  line-height: $line-height;
  letter-spacing: 0px;
  background:black;
  overscroll-behavior-x: none;
  overflow-x:hidden;
  padding-left:$page-margin-x;
  padding-right:$page-margin-x;
  scroll-behavior: smooth;
} 
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: white;
  width: 100%;
  height: $page-height;
}
a,
.underline {
  color: white;
  cursor: pointer;
  text-decoration: none;
  -webkit-box-shadow:inset 0px -1px 0px 0px white;
  -moz-box-shadow:inset 0px -1px 0px 0px white;
  box-shadow:inset 0px -1px 0px 0px white;
}

a.no_underline,
a:hover,
.underline:hover {
  -webkit-box-shadow:none;
  -moz-box-shadow:none;
  box-shadow:none;
}

.big-text {
  font-size: 1.2rem;
  line-height: 1.3rem;
  letter-spacing: 0px;
}
.chat-label {
  position: fixed;
  left:50vw;
  bottom:0;
  height: $chat-label-height;
  line-height: $chat-label-height;
  vertical-align:middle;
  cursor:pointer;

  img {
    height:16px;
    position: relative;
    top:2px;
  }
}

.feature-1 {background-color:#f5f5b7;}
.feature-2 {background-color:#de4501;}
.feature-3 {background-color:#5d4016;}
.feature-4 {background-color:#ebd999;}
.feature-5 {background-color:#a6d50d;}
.feature-6 {background-color:#b9a601;}
.feature-7 {background-color:#0e75ff;}
.feature-8 {background-color:#6e66d5;}
.feature-9 {background-color:#0057b9;}
.feature-10 {background-color:#65aa8e;}
.feature-11 {background-color:#00d873;}
.feature-12 {background-color:#1b8f14;}
.feature-13 {background-color:white;}

// .feature-H {background-color:#0065ff;}
// .feature-L {background-color:#009300;}
// .feature-P {background-color:#e77803;}
// .feature-R {background-color:#7cdb00;}
// .feature-S {background-color:#ffe001;}
// .feature-T {background-color:#808076;}
// .feature-U {background-color:#0000d6;}
// .feature-V {background-color:#004600;}
// .feature-A {background-color:#d3d3d3;}

/* ############### DASHBOARD ###############*/

/* ############### HEADER ###############*/
.header {
  position: fixed;
  width: 100%;
  display: flex;
  justify-content: space-between;
  left:0;
  top:0;
  box-sizing: border-box;
  background:black;
  z-index:1;
  padding-top:$header-padding-top;
  padding-bottom:$header-padding-bottom;
  padding-left:$page-margin-x;
  padding-right:$page-margin-x;
}
.header__logo {
  position:absolute;
  // font-size: 150%;
  // margin-right: 3rem;
  height:$line-height*2;
  top: ($header-padding-top) - ($line-height*0.5);
}
.header__counters {
  display: flex;
  padding-left: $streaminfo-margin-x;
}
.header__socials {
  flex-grow: 1;
  text-align: right;
}
.header__player-nowplaying-wrapper {
  position: absolute;
  display: flex;
  justify-content: center;
  width: 100%;
  pointer-events: none;
}
.header__player-nowplaying {
  display: flex;
  pointer-events: all;
  background:black;
}
.reveil-now-playing__live-now-location {
  cursor: pointer;
  display: inline-block;
  width: 30rem;
  white-space: nowrap;
  overflow: hidden;
  vertical-align: top;
  text-overflow: ellipsis;
}
.monospace-digit {
  letter-spacing: 1px;
  /* to account for the extra linespace at the bottom of the text, e.g. for y's and g's*/
  position: relative;
  top:0.15rem
}
.hidden {
  visibility: hidden;
}

/* ############### IRC ###############*/
.irc {
  position:fixed;
  transition: opacity 0.1s;
  top:$irc-top;
  height:$irc-height;
  width: calc( 0.65 * (100vw - (2*$page-margin-x) - (2*$streaminfo-margin-x) ) );
  left:calc( 
      $streaminfo-margin-x
      + $page-margin-x
      + (0.35 * (100% - (2*$page-margin-x) - (2*$streaminfo-margin-x) ) )
  );

  .irc__inner-container {
    height:100%;
    iframe {
      box-sizing: border-box;
      border: 2px solid white;
      height:100%;
    }
  }
}
.irc-hidden {
  opacity: 0;
  z-index: -1;
}

/* ############### SCROLLER ###############*/

.scroller {
  margin-top: $ref-header-height;
  position: relative;

  .scroller__nav {
    position: relative;
    margin-top:$scroller-nav-margin-top;

    div {
      cursor: pointer;
      user-select: none;
      img {
        width: 16px;
      }
    }
  }
  .scroller__reset {
    position: absolute;
    text-align: center;
    width: 100%;
    left:0px;
    top:0px;
  }
  .scroller__e {
    position: absolute;
    top:0px;
    right: 0px;
  }
  .scroller__utc-offset {
    position: absolute;
    bottom:0px;
    padding-left: 10px;
  }
  .scroller__container {
    height: $scroller-main-height;
    overflow-x: hidden;
    left: 0px;
    top: 0px;
    width: 100%;
    overflow: hidden;
    cursor: grab;
  }
  .scroller__main {
    image-rendering: pixelated;
    background-image: url('./assets/2x/grid.png');
    background-position: bottom left;
    background-repeat: repeat-x;
    background-size: 700px 19px;
    position: absolute;
    left: 0px;
    top: 0px;
    height:50vh; // to change vertical spacing of schedule streams
  }
}

/* ############### SCROLLER-ITEM ###############*/
.scroller-item {
  position: absolute;
  top: calc(100% - 50px ); // y-baseline for streams
  white-space: nowrap;
  overflow:hidden;

  .scroller-item__text {
    display: inline-block;
    height: $line-height; //2.5vh;
    line-height: $line-height; //2.5vh;
    padding:2px 4px;

    .scroller-item__dot {
      display: inline-block;
      height: calc($line-height*0.72);
      width: calc($line-height*0.72);
      margin-top:calc($line-height*0.28 / 2);
      border-radius: 50%;
      margin-right: 1px;
    }
    .scroller-item__triangle {
      display: inline-block;
      height: calc($line-height*0.8);
      width: calc($line-height*0.8);
      margin-top:0rem;
      aspect-ratio: 1;
      clip-path: polygon(0 100%,100% 100%,50% 0%);
      margin-right: 1px;
    }
    span {
      vertical-align: top;
      position: relative;
      top:2px;
    }
  }
}
.selected-stream,
.scroller-item__text:hover {
    color:black;
    cursor: pointer;
    .scroller-item__dot,
    .scroller-item__triangle {
      background-color: black !important;
    }
}

/* ############### STREAM INFO ###############*/
.stream-info {
  height: $streaminfo-main-height;
  padding-top:$streaminfo-padding-top;
  padding-left: $streaminfo-margin-x;
  padding-right: $streaminfo-margin-x;
  white-space: nowrap;
  box-sizing: border-box;
}
.stream-info > * {
  display: inline-block;
  vertical-align: top;
  height:100%;
  white-space: normal;
  box-sizing: border-box;
}
.stream-info__mobile-divider {
    display: none;
}
.stream-info__data {
  width: 20%;
  padding-right:$streaminfo-gap;
}
.stream-info__feature-code-container {
  display: flex;
  flex-direction: row;
}
.stream-info__dot {
  display: inline-block;
  height: calc($line-height*0.72);
  width: calc($line-height*0.72);
  margin-top:calc($line-height*0.28 / 2);
  position: relative;
  top:-2px;
  vertical-align: top;
  margin-right: 1px;
  border-radius: 50%;
  flex-shrink: 0;
}
.stream-info__triangle {
  display: inline-block;
  height: calc($line-height*0.8);
  width: calc($line-height*0.8);
  margin-top:0rem;
  margin-right: 1px;
  position: relative;
  top:-2px;
  vertical-align: top;
  aspect-ratio: 1;
  clip-path: polygon(0 100%,100% 100%,50% 0%);
  flex-shrink: 0;
}
.stream-info__image {
 width: 15%;
 padding-right:$streaminfo-gap;
}
.stream-info__description {
 width: 65%;
}
.stream-info__data-grid
 {
  display: flex;
  justify-content: space-between;
}
.stream-info__image {
  img {
    max-width: 100%;
    max-height:100%;
    float:right;
  }
}
.stream-info__description {
  position: relative;
  height:100%;
  column-count: 3;
  column-gap:3rem;
  column-fill: auto;
  overflow: hidden;
  word-wrap: break-word;

  .stream-info__view-stream-page {
    background:black;
  }
  .stream-info__view-stream-page {
    position: absolute;
    bottom:0;
    left: calc( 66.6% + 2rem);
    width:999px;
  }
}

/* ############### MOBILE PORTRAIT ###############*/
@media screen and (orientation:portrait),
       screen and (max-width:800px)  {
  html {
    font-size: $mobile-font-size;
    line-height: $mobile-line-height;
    padding-left: $mobile-page-margin-x;
    padding-right: $mobile-page-margin-x;
  }
  #app {
    height: auto;
  }
  .header {
    position: absolute;
    height:$mobile-head-height;
    line-height: $mobile-head-height;
    padding: 0 $mobile-page-margin-x;
    vertical-align: middle;
    align-items: center;
    border-bottom: 2px solid white;
  }
  .header__socials {
    display: none;
  }
  .header__player-nowplaying {
    background:transparent;
  }
  .header__player-nowplaying-wrapper {
    position: static;
    width: auto;
    flex-grow: 1;
    justify-content: flex-start;
    padding-left: 2rem;
  }
  .header__logo {
    position: static;
    // font-size:2.3rem;
    // height:$line-height*2;
    // white-space: nowrap;
    // width: auto;
    // height:auto;
    // -webkit-box-flex: 1;
    // -ms-flex-positive: 1;
    // flex-grow: 1;
    // -webkit-box-pack: start;
    // -ms-flex-pack: start;
    // justify-content: flex-start;
  }
  .header__counters {
    font-size:1.3rem;
    padding-left: 0;
  }
  .reveil-player {
    top:0.95rem !important;
  }
  .play, .pause,.play-obj,.pause-obj {
    height: 3rem !important;
    width: 3rem !important;
  }
  .reveil-now-playing, {
    position: absolute;
    left: $mobile-page-margin-x;
    top: calc( ($mobile-head-height) + ($mobile-vertical-spacing) );
    width: calc(100% - (2 * $mobile-page-margin-x) );
  }
  .scroller {
    display: none;
  }
  .irc {
    position: static;
    opacity: 1;  
    width: 100%;
    height:auto;
    padding-top:calc( ($mobile-head-height) + (2*$mobile-vertical-spacing) + ($mobile-line-height * 2) );
    padding-bottom:$mobile-vertical-spacing;
    overflow:hidden;
  }
  .irc .irc__inner-container iframe{
    height: 50vh;
  }
  .stream-info {
    padding-top: 0;
    padding-left: 0;
    padding-right:0;
    margin-bottom: 0;
    height:auto;
    white-space: initial;
  }
  .stream-info__mobile-divider {
    display: block;
    border-top: 2px solid white;
  }
  .stream-info > * {
    width: 100%;
    height:auto;
    padding-right:0;
    padding-left:0;
    padding-bottom: $mobile-vertical-spacing;
  }
  // .stream-info__description {
    // display: block;
  // }

  .stream-info__image {
    img {
      float:left;
      height:auto;
      min-width:40%;
      max-height:50vh;
      max-width: 80%
    }
  }
  .stream-info__description {
    column-count: 1;
    overflow: visible;
  }
  .chat-label {
    display: none;
  }
  .stream-info__view-stream-page {
    display: inline-block;
    position: static !important;
    padding-top: $mobile-vertical-spacing;
    background:none;
    width:auto !important;
  }
  .reveil-now-playing__live-now-location {
    width:100%;
  }
}

/* ############### CUSTOM WIDTHS ###############*/
@media only screen and (max-width: 1200px) and (orientation:landscape) {
  .reveil-countdown,
  .header__counters-spacer,
  .reveil-timer {
    display: none;
  }
}

@media only screen and (max-width: 800px) and (orientation:landscape) {
  .irc {
    height: 80vh;
  }
}

@media only screen and (max-width: 350px) {
  .reveil-countdown,
  .header__counters-spacer {
    display: none;
  }
}
@media only screen and (max-width: 225px) {
  .reveil-timer {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue